module.exports = __webpack_public_path__ + "static/img/s20.08c75b3f.png";